import BackupIndex from "@/views/backup/BackupIndex.vue";

const backup = [
    {
        path: '/backup',
        name: 'backup',
        component: BackupIndex,
        meta: {
            requiresAuth: true,
            roles: ["Super Admin"],
        }
    }
]

export default backup;
